<div class="ps-flex-container-col">
  <pw-file-input multiple="true" (filesChanged)="filesChanged($event)"></pw-file-input>

  <div style="justify-self: end">
    <button mat-button (click)="cancel()">
      <mat-icon>cancel</mat-icon>
    </button>

    <button mat-button (click)="uploadFiles()">
      <mat-icon>file_upload</mat-icon>
    </button>
  </div>
</div>


